<template>
  <label :style="{ 'color': color, 'min-height': length + 'px', 'min-width': length + 'px' }">
    <span :style="{ 'padding-right' : (padding) + 'px' }" v-if="tips !== ''">{{ tips }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" baseProfile="full" 
      viewBox="0 0 72 72" :width="length" :height="length">
      <g :fill="color">
        <path d="M0,34.3c0.4-8.9,4.1-17.4,10.7-23.8C17,4.1,25.6,0.4,34.5,0c-0.4,8.9-4.1,17.4-10.7,23.8C17.5,30.2,8.9,33.9,0,34.3z"/>
        <path d="M34.5,72C15.8,71.3,0.6,56,0,37.3C18.7,38,33.8,53.1,34.5,72z"/>
        <path d="M48.2,23.8C41.6,17.4,37.9,8.9,37.5,0C46.4,0.4,55,4.1,61.3,10.5c6.6,6.4,10.3,14.9,10.7,23.8
        C63.1,33.9,54.5,30.2,48.2,23.8z"/>
        <path d="M72,37.3C71.4,56,56.2,71.3,37.5,72C38.2,53.1,53.3,38,72,37.3z"/>
      </g>
    </svg>
  </label>
</template>

<script>
export default {
  data () {
    return {
      padding: parseInt(this.length) + 4
    }
  },
  props: {
    color: {
      type: String,
      default: '#D0121B'
    },
    length: {
      type: Number,
      default: 50
    },
    tips: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
label {
  position: relative;
}

label span {
  display: inline-block;
}

label svg {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-55%);
}
</style>




// WEBPACK FOOTER //
// src/components/commons/Coin.vue